import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';

export default function AboutHero() {
  const data = {};
  return (
    <>
      <Breadcrumb items={[{ label: 'خانه', to: '/' }, { label: 'درباره ما' }]} position="center" />
      <SectionHead
        tag={'دربارهٔ ما'}
        title={'همه‌چیز خودرو، در یک پلتفرم هوشمند'}
        text="کارا با هدف ساده‌کردن دنیای پیچیدهٔ خدمات خودرو ساخته شد؛ از استعلام خلافی و بیمه تا خرید قطعه و پیش‌بینی هوشمند هزینه‌ها."
        headingTag="h1"
        type="otherPages"
        position={'center'}
      />
    </>
  );
}
